<template>
  <div>
    <div class="row mb-1">
      <div class="col-lg-12">
        <slot name="actionArea" />
        <ContentTitle>{{title}}</ContentTitle>
        <ContentSubTitle v-if="subTitle">{{subTitle}}</ContentSubTitle>
      </div>
    </div>
    <div class="row">
      <slot name="dataArea" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DataPageArea",
  props: {
    title: String,
    subTitle: String
  }
}
</script>